// Copyright (c) 2016 Deere & Company

import appConfig from './app-config';

export default appConfig;



// WEBPACK FOOTER //
// ./src/app-config/reducers/index.js